import { Currency, CountryId } from "@izettle/constants"

export enum CustomerType {
  B2B = "B2B",
  B2C = "B2C",
}

export type Phone = {
  countryCode: string
  number: string
}

export type Customer = {
  uuid: string
  firstName: string
  lastName: string
  companyName: string
  customerType: CustomerType
  contactInfo: {
    email: string
    phoneNumber: Phone
  }
  notes: string
  createdAt: string
  updatedAt: string
}

export type CustomerInfoType = {
  firstName: string
  lastName: string
  email: string
  phone?: Phone
}

export type CustomerContactInfoType = {
  email?: string
  phone?: Phone
}

export type SendReceiptPostMutateProps = {
  contactInfo: CustomerContactInfoType
  customerUuid: string
  purchaseUuid: string
}

export type SignUpPostMutateProps = {
  customerInfo: CustomerInfoType
  orgUuid: string
  purchaseUuid: string
}

export type SendReceiptPostProps = {
  onSuccess?: (_data: ServiceFailedToReturn & CustomerContactInfoType) => void
}

export type SignUpPostProps = {
  onSuccess: (_data: Customer) => void
}

export type SellerFetchType = {
  uuid: string
  name: string
  receiptName?: string
  legalName?: string
  address: string
  addressLine2: string
  zipCode: string
  city: string
  country: CountryId
  language: string
  profileImageUrl: string
  state: string
  contactEmail: string
  phoneNumber: string
  privacyPolicyLink: string
}

export type PurchaseDetailFetchType = {
  uuid: string
  refund: boolean
  refunded: boolean
  created: string
  amount: number
  currency: Currency
  seller: SellerFetchType
}

export type SellerInfoType = {
  orgName: string
  orgLogoUrl: string
  orgPhoneNumber: string
  orgContactEmail: string
  orgPrivacyPolicyLink: string
}

export type PurchaseDetailType = {
  orgName: string
  orgLogoUrl: string
  receiptAmount: string
  receiptTime: string
  orgPhoneNumber: string
  orgContactEmail: string
  orgPrivacyPolicyLink: string
}

export enum FailureMessage {
  PURCHASE_NOT_FOUND = "PURCHASE_NOT_FOUND",
  CUSTOMER_OR_PURCHASE_NOT_FOUND = "CUSTOMER_OR_PURCHASE_NOT_FOUND",
  CUSTOMER_NOT_FOUND = "CUSTOMER_NOT_FOUND",
  SELLER_NOT_FOUND = "SELLER_NOT_FOUND",
  PHONE_OR_EMAIL_REQUIRED = "PHONE_OR_EMAIL_REQUIRED",
  INVALID_INPUT = "INVALID_INPUT",
  PURCHASE_ALREADY_ASSOCIATED = "PURCHASE_ALREADY_ASSOCIATED",
  EMAIL_OR_PHONE_ALREADY_EXISTS = "EMAIL_OR_PHONE_ALREADY_EXISTS",
  OPERATION_ERROR = "OPERATION_ERROR",
}

export type ServiceError = {
  developerMessage?: string
}

export type ServiceFailedToReturn = {
  failureMessage?: FailureMessage
}
